var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Weekdays } from '../../constants/constants';
import Button from '../button';
import ButtonGroup from '../button-group';
import { Styled } from './style';
var WeekdayPicker = /** @class */ (function (_super) {
    __extends(WeekdayPicker, _super);
    function WeekdayPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (item) {
            var items = __assign({}, _this.props.items);
            items[item.key] = !items[item.key];
            if (_this.props.callback) {
                _this.props.callback(items);
            }
        };
        _this.state = {
            keys: _this.props.keys || Weekdays,
        };
        return _this;
    }
    WeekdayPicker.prototype.render = function () {
        var _this = this;
        var buttons = this.state.keys.map(function (item) { return (React.createElement(Button, { className: "weekday-" + item.key, key: item.key, toggle: true, disabled: _this.props.disabled, active: _this.props.items[item.key], onClick: function () { return _this.handleClick(item); } }, item.short || item.text)); });
        return (React.createElement(Styled, null,
            React.createElement(ButtonGroup, null, buttons)));
    };
    return WeekdayPicker;
}(React.Component));
export { WeekdayPicker };
export default WeekdayPicker;
//# sourceMappingURL=index.js.map